<div class="wrapper">
  <div class="spinner-container">
    <div class="box">
      <object
        type="image/svg+xml" 
        data="../../../../assets/Loading-Indicator-icon.svg"
        width="204"
        height="204">
      </object>
    </div>
    <div class="box top-box">
      <div class="box info-box">{{ "Shell.generic.loadingDataInfo" | translate }}</div>
    </div>
  </div>
</div>
